@if (show()) {
  <div
    class="pa-setup"
    data-testid="pa-onboarding"
    [@.disabled]="reduceMotion"
    @pageFade>
    <div class="pa-setup__panel" @stepStagger>
      <div class="pa-setup__greeting">
        <h1 class="pa-setup__title">Welcome, {{ firstName() || 'there' }}.</h1>
        <div class="pa-setup__sub">
          Let's get your assistant set up. Takes about a minute, and you only do
          this once.
        </div>
        <div class="pa-setup__divider" aria-hidden="true"></div>
      </div>

      <section class="pa-setup__card">
        <div class="pa-setup__badge">Step 1</div>
        <h2 class="pa-setup__h2">Plan for which organization?</h2>
        <div class="pa-setup__card-sub">
          This is the organization your assistant will pull patients from.
          Change anytime via the org filter.
        </div>

        <aiomed-pa-org-picker variant="setup" />
      </section>

      <section class="pa-setup__card">
        <div class="pa-setup__badge">Step 2</div>
        <h2 class="pa-setup__h2">Which units do you monitor?</h2>
        <div class="pa-setup__card-sub">
          Scopes your plan to only patients in your units. You can change this
          from Home anytime.
        </div>

        <aiomed-pa-unit-multiselect
          [units]="units()"
          [selected]="selectedUnits()"
          [orgName]="orgName()"
          (selectedChange)="onUnitsChange($event)" />
      </section>

      <section class="pa-setup__card">
        <div class="pa-setup__badge">Step 3</div>
        <h2 class="pa-setup__h2">How much time do you have today?</h2>
        <div class="pa-setup__card-sub">
          Your plan fills in priority order to fit your time. You can change
          this any morning from Home.
        </div>

        <aiomed-pa-time-picker
          variant="card"
          [value]="time()"
          (valueChange)="onTimeChange($event)" />
      </section>

      <div class="pa-setup__actions">
        <button type="button" class="pa-setup__skip" (click)="skip()">
          <i class="ph ph-arrow-right" aria-hidden="true"></i> Skip for now
        </button>
        <button type="button" class="pa-setup__cta" (click)="seeMyPlan()">
          See my plan <i class="ph ph-arrow-right" aria-hidden="true"></i>
        </button>
      </div>

      <div class="pa-setup__foot">
        You can update your organization, units, and time anytime from your My
        Plan page.
      </div>
    </div>
  </div>
}
